import httpCommon from "./http-common";

// Get AI configurations
const getAIConfigurations = (businessId?: number) => {
  const url = businessId ? `/v1/get/aiConfiguration?businessId=${businessId}` : '/v1/get/aiConfiguration';
  return httpCommon.get(url);
};

// Create AI configuration
const createAIConfiguration = (data: any) => {
  return httpCommon.post('/v1/add/aiConfiguration', data);
};

// Update AI configuration
const updateAIConfiguration = (id: number, data: any) => {
  return httpCommon.put(`/v1/update/aiConfiguration/${id}`, data);
};

// Delete AI configuration
const deleteAIConfiguration = (id: number) => {
  return httpCommon.delete(`/v1/delete/aiConfiguration/${id}`);
};

// Get AI configuration by ID
const getAiConfigurationById = (configId: number) => {
  return httpCommon.get(`/v1/get/aiConfiguration/${configId}`);
};

// Get configurations by type
const getConfigurationsByType = (businessId: number, configType: string) => {
  return httpCommon.get(`/v1/get/aiConfiguration/type/${configType}?businessId=${businessId}`);
};

// Get system-wide configurations
const getSystemConfigurations = () => {
  return httpCommon.get("/v1/get/aiConfiguration/system");
};

// Update multiple configurations
const bulkUpdateConfigurations = (configurations: any[]) => {
  return httpCommon.put("/v1/bulk/update/aiConfiguration", { configurations });
};

// Reset configurations to default
const resetToDefaults = (businessId: number, configTypes: string[]) => {
  return httpCommon.post("/v1/reset/aiConfiguration", {
    businessId,
    configTypes
  });
};

// Test AI configuration
const testAiConfiguration = (configId: number, testData: any) => {
  return httpCommon.post(`/v1/test/aiConfiguration/${configId}`, testData);
};

// Test AI model connection
const testModelConnection = (configId: number) => {
  return httpCommon.post(`/v1/test/aiConfiguration/${configId}`);
};

// Get model performance metrics
const getModelPerformanceMetrics = (businessId: number) => {
  return httpCommon.get(`/v1/get/aiConfiguration/metrics/${businessId}`);
};

// Update model settings
const updateModelSettings = (businessId: number, data: any) => {
  return httpCommon.put(`/v1/update/aiConfiguration/settings/${businessId}`, data);
};

// Get extraction rules
const getExtractionRules = (businessId: number, documentTypeId?: number) => {
  const url = documentTypeId 
    ? `/v1/get/aiConfiguration/extraction-rules/${businessId}?documentTypeId=${documentTypeId}`
    : `/v1/get/aiConfiguration/extraction-rules/${businessId}`;
  return httpCommon.get(url);
};

// Update extraction rules
const updateExtractionRules = (businessId: number, data: any) => {
  return httpCommon.put(`/v1/update/aiConfiguration/extraction-rules/${businessId}`, data);
};

// Get validation settings
const getValidationSettings = (businessId: number) => {
  return httpCommon.get(`/v1/get/aiConfiguration/validation/${businessId}`);
};

// Update validation settings
const updateValidationSettings = (businessId: number, data: any) => {
  return httpCommon.put(`/v1/update/aiConfiguration/validation/${businessId}`, data);
};

// Get processing settings
const getProcessingSettings = (businessId: number) => {
  return httpCommon.get(`/v1/get/aiConfiguration/processing-settings/${businessId}`);
};

// Update processing settings
const updateProcessingSettings = (businessId: number, data: any) => {
  return httpCommon.put(`/v1/update/aiConfiguration/processing-settings/${businessId}`, data);
};

// Get system health
const getSystemHealth = () => {
  return httpCommon.get('/v1/get/aiConfiguration/system-health');
};

// Test connection
const testConnection = () => {
  return httpCommon.post('/v1/test/aiConfiguration/connection');
};

const AIConfigurationService = {
  getAIConfigurations,
  createAIConfiguration,
  updateAIConfiguration,
  deleteAIConfiguration,
  getAiConfigurationById,
  getConfigurationsByType,
  getSystemConfigurations,
  bulkUpdateConfigurations,
  resetToDefaults,
  testAiConfiguration,
  testModelConnection,
  getModelPerformanceMetrics,
  updateModelSettings,
  getExtractionRules,
  updateExtractionRules,
  getValidationSettings,
  updateValidationSettings,
  getProcessingSettings,
  updateProcessingSettings,
  getSystemHealth,
  testConnection
};

export default AIConfigurationService; 